import { useCallback, useEffect, useState } from "react";
import { Input } from "@/components/ui/input";
import { parseNumericBound } from "./FieldFilter.model";

interface NumericBoundInputProps {
  label: string;
  value?: number;
  onSubmit: (value: number) => void;
}

export function NumericBoundInput({
  label,
  value,
  onSubmit,
}: NumericBoundInputProps) {
  const [amount, setAmount] = useState(value != null ? String(value) : "");

  useEffect(() => {
    setAmount(value != null ? String(value) : "");
  }, [value]);

  const handleSubmit = useCallback(() => {
    if (amount === "") {
      return;
    }

    const parsed = parseNumericBound(amount);
    if (parsed == null || parsed === value) {
      return;
    }

    onSubmit(parsed);
  }, [amount, value, onSubmit]);

  const handleChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) =>
      setAmount(event.target.value),
    []
  );

  const handleKeyDown = useCallback(
    (event: React.KeyboardEvent<HTMLInputElement>) => {
      if (event.key === "Enter") {
        handleSubmit();
      }
    },
    [handleSubmit]
  );

  return (
    <Input
      type="number"
      placeholder={label}
      value={amount}
      onChange={handleChange}
      onKeyDown={handleKeyDown}
      onBlur={handleSubmit}
      className="w-[214px] h-6"
    />
  );
}
